import AppContext from 'App/AppContext';
import { IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalTextStylesBold } from 'globalStyles';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface INewVersionNotificationProps {}

export const NewVersionNotificationHeight = 22;
export const NewVersionNotificationWidth = 60;

const NewVersionNotification = (props: INewVersionNotificationProps) => {
  const { t } = useTranslation(['translation', 'library']);
  const appContext = useContext(AppContext);

  return (
    <IPStack
      horizontalAlign="center"
      verticalAlign="center"
      disableShrink
      styles={{
        root: {
          borderRadius: '3px',
          width: NewVersionNotificationWidth,
          height: NewVersionNotificationHeight,
          maxWidth: NewVersionNotificationWidth,
          maxHeight: NewVersionNotificationHeight,
          padding: 3,
          background: appContext.useDarkMode ? '#36b357' : '#7ed999',
          opacity: 0.9,
        },
      }}
    >
      <IPStack.Item>
        <IPText variant="small" styles={globalTextStylesBold}>
          {t('library:Preview.NewVersion')}
        </IPText>
      </IPStack.Item>
    </IPStack>
  );
};

export default NewVersionNotification;
